require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./gruppo-di-ricerca-orietta-lanzarini.json") })
        }
      }, "path---gruppo-di-ricerca-orietta-lanzarini");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---gruppo-di-ricerca-orietta-lanzarini!./.cache/json/gruppo-di-ricerca-orietta-lanzarini.json
// module id = 664
// module chunks = 231608221292675